import { EscalationsExport } from 'Features/EscalationsExport';
import { AuditQueue, AuditReport } from 'Features/QualityAssurance';
import { Reviewers } from 'Features/Reviewers';
import { Permission } from 'Models/Templates/Permission/Permission';
import { SubRoutes, DropdownSubRouteConfig } from 'Navigation';

export enum ComplianceSubRoute {
  EscalationsExport = '/EscalationsExport',
  AuditQueue = '/AuditQueue',
  AuditReport = '/AuditReport',
}

export const ComplianceSubRoutes: SubRoutes = {
  [ComplianceSubRoute.EscalationsExport]: new DropdownSubRouteConfig(
    ComplianceSubRoute.EscalationsExport,
    'Escalations Export',
    EscalationsExport,
    [Permission.ViewEscalationsExport]
  ),
  [ComplianceSubRoute.AuditQueue]: new DropdownSubRouteConfig(
    ComplianceSubRoute.AuditQueue,
    'Audit Queue',
    AuditQueue,
    [Permission.ViewAuditQueue]
  ),
  [ComplianceSubRoute.AuditReport]: new DropdownSubRouteConfig(
    ComplianceSubRoute.AuditReport,
    'Audit Report',
    AuditReport,
    [Permission.ViewAuditReport]
  ),
};
